import { jsx as _jsx } from "react/jsx-runtime";
import { flexRender } from '@tanstack/react-table';
import { twMerge } from 'tailwind-merge';
export const TableFooterCell = ({ header, className }) => {
    var _a;
    const meta = (_a = header.column.columnDef.meta) !== null && _a !== void 0 ? _a : {};
    const { rightAlign, grow } = meta;
    return (_jsx("div", { className: twMerge('border-t-primary flex border-t px-2 py-3', grow ? 'grow' : '', rightAlign ? 'justify-end' : '', className), children: header.isPlaceholder
            ? null
            : flexRender(header.column.columnDef.footer, header.getContext()) }));
};
//# sourceMappingURL=TableFooterCell.js.map